import AbstractApiModel from '../modelx/models/abstracts/AbstractApiModel';

const defaultUrnRegex = /\$:([a-z]+):([a-z_]+):(\d+)/;

export const splitUrn = (urn: string): string[] => {
	// even with typing, sometimes urn is not a string!!!
	if (!urn || typeof urn !== 'string') {
		return [];
	}

	const regex = new RegExp(defaultUrnRegex);
	const matches = urn.match(regex);

	if (!matches || matches.length !== 4) {
		console.warn('Urn "%s" does not match defaultUrnRegex', urn);

		return [];
	}

	return matches;
};

export const getMaskFromUrn = (urn: string): string => {
	const urnParts = splitUrn(urn);
	return `$:${urnParts[1]}:${urnParts[2]}:*`;
};

export const getIdFromUrn = (urn: string): string => splitUrn(urn)[3] || '';

export const getEntityFromUrn = (urn: string): string => splitUrn(urn)[2] || '';

export const getIdFromIri = (iri: string): string => {
	if (!iri) {
		return '';
	}

	const index = iri.lastIndexOf('/');

	if (index < 0) {
		return '';
	}

	return iri.substr(index + 1);
};

export function getUrnFromId<T extends typeof AbstractApiModel>(
	modelClass: T,
	id: T['prototype']['id']
) {
	return [
		modelClass.urnData.partition,
		modelClass.urnData.service,
		modelClass.urnData.resource,
		id,
	].join(':') as Urn;
}

export function isUrn(string: string) {
	const pattern = /^\$:[a-zA-Z_]+:[a-zA-Z_]+:\d+$/;
	return pattern.test(string);
}